// Dev-only console logger. Silent in production builds.
// Usage: import { devError } from "../lib/log";  devError(e);
const isDev = process.env.NODE_ENV !== "production";

export const devError = (...args) => { if (isDev) console.error(...args); };
export const devLog = (...args) => { if (isDev) console.log(...args); };
